import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root', // This makes the service a singleton available throughout the app.
})
export class JsonToStringConversion {


}